//LOGIN
export const REGISTER_REQUEST="REGISTER_REQUEST"
export const REGISTER_SUCESS="REGISTER_SUCESS"
export const REGISTER_FAIL="REGISTER_FAIL"
//SIGNUP
export const LOGIN_REQUEST="LOGIN_REQUEST"
export const LOGIN_SUCESS="LOGIN_SUCESS"
export const LOGIN_FAIL="LOGIN_FAIL"